import {useAppSelector} from "../../../redux/store";
import {useOutletContext} from "react-router-dom";
import {MessageLoader} from "./message.loader";
import {MessageSections} from "../../../pages/components/message/message";
import {Content, MainContentContainer} from "../../styled";
import {Sidebar} from "../../../pages/sidebar";
import {WarehouseOrdersPage} from "../../../management-pages/orders";
import {Footer} from "../../../pages/footer/footer";
import {WarehouseOrders} from "../../../management-pages/orders/warehouse-my";
import OrderPopup from "../../../pages/orders/order-popup/order-popup";
import {OrderModel} from "../../../pages/shared/models/order/order-item.model";
import AdditionalServicesPage from "../../../management-pages/additional-services";
import React from "react";
import {OutletContext} from "../../router";
import RouteError from "../../../pages/info/route-error";
import {globalHeaderRef} from "../../../pages/shared/refs";

export const WarehouseWorkerRoutes = {
    path: 'management/warehouse-orders',
    Component: () => {
        const {isOpen} = useAppSelector(state => state.sidebarReducer);
        const {matchesTablet, matchesPc} = useAppSelector(state => state.deviceReducer);

        const outletContext = useOutletContext<OutletContext>();

        return (
            <MessageLoader key={MessageSections.ORDERS} sectionName={MessageSections.ORDERS}>
                <MainContentContainer id={'main-content-container'}>
                    <Sidebar headerRef={globalHeaderRef}/>
                    <Content
                        style={{
                            paddingLeft: isOpen
                            && (matchesTablet || matchesPc) ? '15rem' : 'unset'
                        }}>
                        <WarehouseOrdersPage context={outletContext}/>

                        <Footer/>
                    </Content>
                </MainContentContainer>
            </MessageLoader>
        )
    },
    children: [
        {
            path: 'my',
            index: true,
            Component: () => {
                return <WarehouseOrders/>;
            }
        },
        {
            path: 'new',
            Component: () => {
                const outletContext = useOutletContext<OutletContext>();
                return OrderPopup({mainContentContainerRef: outletContext.mainContentContainerRef})
            }
        },
        {
            path: ':orderId',
            loader: () => {
                return {} as OrderModel
            },
            Component: () => {
                const outletContext = useOutletContext<OutletContext>();
                return OrderPopup({mainContentContainerRef: outletContext.mainContentContainerRef})
            }
        },
        {
            path: 'dashboard',
            element: <></>
        },
        {
            path: 'additional-services',
            element: <AdditionalServicesPage/>
        },
        {
            path: '*',
            element: <RouteError/>
        }
    ]
}